<template>
  <v-card color="grey lighten-4" flat tile>
    <v-toolbar elevation="0" color="grey lighten-3">
      <a href="https://aquapaddle.org" title="Return to the AquaPaddle website">
        <img src="/img/logo-transparent.png" height="40" />
      </a>

      <v-spacer></v-spacer>

      <v-menu v-if="this.$store.state.user.organiser">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item to="/organiser">
            <v-list-item-title>Organiser</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="this.$store.state.user.admin"
            to="/admin/incident-reports"
          >
            <v-list-item-title>Incident Reports</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="this.$store.state.user.admin"
            to="/admin/locations"
          >
            <v-list-item-title>Locations</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="this.$store.state.user.admin" to="/admin/users">
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="this.$store.state.user">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" icon v-bind="attrs" v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item to="/">
            <v-list-item-title>Paddles</v-list-item-title>
          </v-list-item>

          <v-list-item to="/user/event-results">
            <v-list-item-title>Results</v-list-item-title>
          </v-list-item>

          <v-list-item to="/user/event-registrations">
            <v-list-item-title>Registrations</v-list-item-title>
          </v-list-item>

          <v-list-item to="/profile/edit">
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>

          <v-list-item to="/account">
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item>

          <v-list-item @click="signOut()">Sign out</v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
  </v-card>
</template>

<script>
export default {
  name: "toolbar",

  methods: {
    signOut() {
      this.$store.commit("signOut");
    },
  },
};
</script>
